import axios from '@/plugins/axios'

function store(data) {
  return axios.post('/finance-models', data).then(response => {
    return response.data
  })
}

function update(data, id) {
  return axios.patch(`/finance-models/${id}`, data)
    .then(response => {
      return response.data
    })
}

export default {
  getAll(query = {}) {
    return axios.get('/finance-models', { params: query }).then(response => {
      return response.data
    })
  },
  getForCountry(countryId, yachtModelId = undefined) {
    return axios.get('/finance-models', { params: { country_id: countryId, yacht_model_id: yachtModelId } })
      .then(response => {
        return response.data
      })
  },
  getTypes() {
    return axios.get('/finance-models/types').then(response => {
      return response.data
    })
  },
  save(data, id) {
    return id ? update(data, id) : store(data, id)
  },
  destroy(id) {
    return axios.delete(`/finance-models/${id}`)
  }
}
